import { cn } from "@/app/utils/cn";
import masks from "@/app/utils/masks";

interface RegistrationCardProps {
  cnpj: string;
  registrationNumber: string;
  onClick: () => void;
  selected: boolean;
}

export default function RegistrationCard({ cnpj, registrationNumber, onClick, selected }: RegistrationCardProps) {
  return (
    <div className={cn("cursor-pointer flex flex-col gap-2 px-4 py-3 rounded-2xl border border-gray01", selected && "border-primary bg-primary/5")} onClick={onClick}>
      <div className="text-sm font-medium text-gray-800">Número de registro: {registrationNumber}</div>
      <div className="text-sm font-medium text-gray-800">CNPJ: {masks.cnpj(cnpj)}</div>
    </div>
  );
}